module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['row-elements', _vm.sub_class, {
      big: _vm.is_big
    }]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row",
    class: [
      _vm.stretch_image ?
      'flex-vertical-align-stretch' :
      'flex-vertical-align-center',
      _vm.auto_height_image ? 'auto-height-image' : '' ]
  }, [_c('div', {
    class: [
      'row-element',
      'col-l-' + _vm.text_size_d,
      'col-m-' + _vm.text_size_t,
      'col-s-' + _vm.text_size_m,
      'order-l-' + _vm.text_order_d,
      'order-m-' + _vm.text_order_t,
      'order-s-' + _vm.text_order_m,
      {
        'col-hide-l': _vm.text_hide_d
      },
      {
        'col-hide-m': _vm.text_hide_t
      },
      {
        'col-hide-s': _vm.text_hide_m
      } ]
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), (_vm.link_label) ? _c('a', {
    staticClass: "btn default",
    attrs: {
      "href": _vm.link_url
    }
  }, [_vm._v(_vm._s(_vm.link_label))]) : _vm._e(), _vm._v(" "), (_vm.extra_link_label) ? _c('a', {
    staticClass: "btn default",
    attrs: {
      "href": _vm.extra_link_url
    }
  }, [_vm._v(_vm._s(_vm.extra_link_label))]) : _vm._e(), _vm._v(" "), (_vm.button_video_true) ? _c('button', {
    staticClass: "btn default show-modal",
    attrs: {
      "id": "show-modal"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.button_video_text)
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13px",
      "height": "14px",
      "viewBox": "0 0 13 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "latest-deck",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "3-offer",
      "transform": "translate(-827.000000, -1427.000000)",
      "fill": "#FFFFFF"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path-2",
      "points": "827 1427 827 1441.03125 839.1875 1434.03125"
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "videoWrapper"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.videosrc,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])]) : _vm._e()], 1)]), _vm._v(" "), (!_vm.is_fixed) ? _c('div', {
    class: [
      'notched',
      {
        notched__enabled: _vm.image_is_notched
      },
      _vm.image_notched_type,
      _vm.image_notched_mobile_type,
      _vm.image_notched_position,
      _vm.image_notched_mobile_position,
      _vm.image_notched_color,
      {
        notched__outside: _vm.image_notched_type
      },
      'row-element image',
      'col-l-' + _vm.image_size_d,
      'col-m-' + _vm.image_size_t,
      'col-s-' + _vm.image_size_m,
      'order-l-' + _vm.image_order_d,
      'order-m-' + _vm.image_order_t,
      'order-s-' + _vm.image_order_m,
      {
        'col-l-hide': _vm.image_hide_d
      },
      {
        'col-m-hide': _vm.image_hide_t
      },
      {
        'col-s-hide': _vm.image_hide_m
      } ],
    style: ({
      'background-image': 'url( ' + _vm.image + ' )',
      'background-position': _vm.horizontal + '% ' + _vm.vertical + '%',
    })
  }, [_c('div', {
    staticClass: "notched-helper"
  })]) : _vm._e(), _vm._v(" "), (_vm.image_2) ? _c('div', {
    class: [
      'row-element image',
      'col-l-' + _vm.image_size_d,
      'col-m-' + _vm.image_size_t,
      'col-s-' + _vm.image_size_m,
      'order-l-' + _vm.image_order_d,
      'order-m-' + _vm.image_order_t,
      'order-s-' + _vm.image_order_m,
      {
        'col-l-hide': _vm.image_hide_d
      },
      {
        'col-m-hide': _vm.image_hide_t
      },
      {
        'col-s-hide': _vm.image_hide_m
      } ],
    style: ({
      'background-image': 'url( ' + _vm.image_2 + ' )'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.image_3) ? _c('div', {
    class: [
      'row-element image',
      'col-l-' + _vm.image_size_d,
      'col-m-' + _vm.image_size_t,
      'col-s-' + _vm.image_size_m,
      'order-l-' + _vm.image_order_d,
      'order-m-' + _vm.image_order_t,
      'order-s-' + _vm.image_order_m,
      {
        'col-l-hide': _vm.image_hide_d
      },
      {
        'col-m-hide': _vm.image_hide_t
      },
      {
        'col-s-hide': _vm.image_hide_m
      } ],
    style: ({
      'background-image': 'url( ' + _vm.image_3 + ' )'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.is_fixed) ? _c('div', {
    class: [
      'row-element image',
      'col-l-' + _vm.image_size_d,
      'col-m-' + _vm.image_size_t,
      'col-s-' + _vm.image_size_m,
      'order-l-' + _vm.image_order_d,
      'order-m-' + _vm.image_order_t,
      'order-s-' + _vm.image_order_m,
      {
        'col-l-hide': _vm.image_hide_d
      },
      {
        'col-m-hide': _vm.image_hide_t
      },
      {
        'col-s-hide': _vm.image_hide_m
      } ]
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": _vm.image
    }
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a02573b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Block.vue
// module id = 314
// module chunks = 0